export const TUTORIALS_LINK = "https://info.drivequant.com/fr/configurer-mon-telephone";
